// btw-front/src/api/adminSignups.js
import { api, getAccessToken } from "./client";

export async function list({ status } = {}) {
  const qs = status ? `?status=${encodeURIComponent(status)}` : "";
  const res = await api.get(`/admin/signups${qs}`);
  return res.items || [];
}

export async function get(id) {
  return api.get(`/admin/signups/${encodeURIComponent(id)}`);
}

export async function approve(id) {
  return api.post(`/admin/signups/${encodeURIComponent(id)}/approve`);
}

export async function reject(id, reason) {
  return api.post(`/admin/signups/${encodeURIComponent(id)}/reject`, { reason });
}

// 첨부 다운로드 — kind = 'brochure' | 'businessRegistration' | 'bankbook' (기본 brochure).
// Authorization 헤더 필요해 a tag 직접 사용 어려움 → fetch 후 Blob 으로 다운받는 헬퍼.
export async function downloadAttachment(id, suggestedName, kind = "brochure") {
  const token = getAccessToken();
  const qs = `?kind=${encodeURIComponent(kind)}`;
  const res = await fetch(`/api/admin/signups/${encodeURIComponent(id)}/attachment${qs}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) {
    // api 레이어는 i18n 미사용 — 영문 폴백. 호출자가 i18n 폴백으로 덮어쓴다.
    let msg = "Download failed";
    try {
      const j = await res.json();
      msg = (j && j.error && j.error.message) || msg;
    } catch (e) {}
    throw new Error(msg);
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = suggestedName || kind;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 500);
}
